<template>
  <div class="columns has-text-centered" v-if="active">
    <div class="column is-one-third">
      <div class="box is-clickable" @click="trackClick('https://amzn.to/3FLsgyR')">
        <p>
          <span class="is-size-4">ELEGOO UNO R3 Starter Kit (*)</span><br>
          <span class="is-size-5">39,82 € statt <s>47,39 €</s></span>
        </p>
        <img src="@/assets/images/advert/prod_arduino.jpg" class="is-product-img pb-3">
        <div>
          <button class="button is-primary" @click="trackClick('https://amzn.to/3FLsgyR')">
            <span class="icon">
              <i class="fas fa-shopping-cart"></i>
            </span>
            <span>
              Jetzt bei Amazon kaufen!
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="column is-one-third is-hidden-mobile">
      <div class="box is-clickable" @click="trackClick('https://amzn.to/30QMA2i')">
        <p>
          <span class="is-size-4">Oszilloskop DOS1102 (*)</span><br>
          <span class="is-size-5">201,67 € statt <s>272,26 €</s></span>
        </p>
        <img src="@/assets/images/advert/prod_oszilloskop.jpg" class="is-product-img pb-3">
        <div>
          <button class="button is-primary" @click="trackClick('https://amzn.to/30QMA2i')">
            <span class="icon">
              <i class="fas fa-shopping-cart"></i>
            </span>
            <span>
              Jetzt bei Amazon kaufen!
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="column is-one-third is-hidden-mobile">
      <div class="box is-clickable" @click="trackClick('https://amzn.to/2ZhU9yQ')">
        <p>
          <span class="is-size-4">Brüder Mannesmann Steckschlüssel und Bitsatz (*)</span><br>
          <span class="is-size-5">14,36 € statt <s>40,25 €</s></span>
        </p>
        <img src="@/assets/images/advert/prod_steckschluessel.jpg" class="is-product-img pb-3">
        <div>
          <button class="button is-primary" @click="trackClick('https://amzn.to/2ZhU9yQ')">
            <span class="icon">
              <i class="fas fa-shopping-cart"></i>
            </span>
            <span>
              Jetzt bei Amazon kaufen!
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GeneralAffiliateBox',
  methods: {
    trackClick (url) {
      this.$matomo && this.$matomo.trackEvent(this.$router.currentRoute.path, 'affiliate-amazon-product', url, 0)
      window.open(url, '_blank').focus()
    }
  },
  data () {
    return {
      active: false
    }
  }
}
</script>

<!--
<template>
    <div class="box has-text-centered-mobile">
      <h3 class="has-text-centered">Amazon Prime Student (*)</h3>
      <div class="columns">
        <div class="column has-text-right-tablet">
          <img src="@/assets/images/advert/prime-student.png" class="is-clickable" @click="trackClick()">
        </div>
        <div class="column has-text-left is-hidden-mobile">
          <ul>
            <li>Kostenloser und schnellerer Versand</li>
            <li>Unbegrenztes Streaming mit Prime Video</li>
            <li>Über zwei Millionen Songs und Podcasts mit Amazon Music</li>
            <li>Premiumzugang zu Blitzangeboten und vieles mehr</li>
          </ul>
          <button class="button is-primary ml-5" @click="trackClick()">Hier anmelden!</button>
        </div>
        <div class="column pt-0 has-text-centered is-hidden-tablet">
          <p class="is-size-7">
            &gt; Kostenloser und schnellerer Versand &lt;<br>
            &gt; Unbegrenztes Streaming mit Prime Video &lt;<br>
            &gt; Über zwei Millionen Songs und Podcasts mit Amazon Music &lt;<br>
            &gt; Premiumzugang zu Blitzangeboten und vieles mehr &lt;
          </p>
          <button class="button is-primary" @click="trackClick()">Hier anmelden!</button>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'GeneralAffiliateBox',
  methods: {
    trackClick () {
      this.$matomo && this.$matomo.trackEvent(this.$router.currentRoute.path, 'affiliate-prime-student', '', 0)
      window.open('https://www.amazon.de/gp/student/signup/info?tag=lachner03-21', '_blank').focus()
    }
  }
}
</script>
-->
